import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlobUrlToListPipe, IHowTo, SafePipe, SlideInOutAnimation } from '@sml/utility';
import { AccordionComponent } from '@sml/accordion';
import { DrawerComponent } from '@sml/drawer';
import { ButtonsModule } from '@sml/buttons';
import { IconsComponent } from '@sml/icons';

@Component({
  selector: 'sml-how-to',
  imports: [
    CommonModule,
    ButtonsModule,
    DrawerComponent,
    AccordionComponent,
    IconsComponent,
    SafePipe,
    BlobUrlToListPipe,
  ],
  templateUrl: './how-to.component.html',
  styleUrl: './how-to.component.scss',
  animations: [SlideInOutAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowToComponent {
  howtoModal = input(false);
  howtoData = input<IHowTo | null>(null);
  hideModal = output();

  closeModal() {
    this.hideModal.emit();
  }
}
